import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import GetCategorias from "../components/getCategorias";
import BreadCrumb from "../components/common/breadCrumb";
import { useTranslation } from "react-i18next";
import { Modal } from "antd";
import MainButton from "../components/common/mainButton";

import store from "../redux/store";
import * as Actions from "../redux/actions";

import Loading from "../components/common/loading";

import ModalContent from "./custom-catalog/modal-content";


const Categorias = () => {

  const { t } = useTranslation(["data"]);

  let { pathname } = useLocation();

  const [categorias, setCategorias] = useState(null);

  const [isMyCatalog, setIsMyCatalog] = useState(null);

  const [modalVisible, setModalVisible] = useState(false);

  const [modalValue, setModalValue] = useState();


  const [loader, setLoader] = useState(true);

  const getRoute = pathname.split("/").filter((el) => el);

  let { catalogoId } = useParams();

  useEffect(() => {
    setLoader(true);

    store.dispatch(Actions.getCategories(catalogoId)).then((data) => {
      setCategorias(data.payload.data.categorias);
      setIsMyCatalog(data.payload.data.isInMyCatalog);
      setLoader(false);
    });
  }, [catalogoId]);


  return (
    <div className="marcas-container">
      {loader && <Loading />}

      <div className="marcasTitle">{t("porCategorias")}</div>

      {getRoute && getRoute.length > 1 && (
        <div className="bread-container">
          <div className="bread">
            <BreadCrumb />
          </div>
          {isMyCatalog && (
            <div
              className="add-products-btn"
              onClick={() => setModalVisible(!modalVisible)}
            >
              <MainButton link={"#"} name={t("anadirProductos")} />
            </div>
          )}
        </div>
      )}

      {modalVisible && (
        <div className="custom-modal-products">
          <Modal
            className="custom-modal-products"
            centered
            visible={modalVisible}
            okText={t("anadirProductos")}
            onCancel={() => setModalVisible(false)}
            onOk={() => 
              
              store.dispatch(Actions.postCustomProducts({catalogoId:catalogoId, modalValue:modalValue})).then(() => {
                store.dispatch(Actions.getCategories(catalogoId)).then((data) => {
                  setCategorias(data.payload.data.categorias);
                  setIsMyCatalog(data.payload.data.isInMyCatalog);
                  setModalVisible(false)
                  setLoader(false);
                });
              })
            
            }
            width={1500}
            >
            <ModalContent setModalValue={setModalValue} modalValue={modalValue}/>
        </Modal>
        </div>
      )}

      {isMyCatalog && categorias && (
        <>
          {categorias.length === 0 && (
            <div className="no-categories">{t("noProductos")}</div>
          )}
        </>
      )}

      {!loader && categorias && (
        <div className="content">
          <GetCategorias pathname={pathname} 
                         categorias={categorias} 
                         isMyCatalog={isMyCatalog} 
                         setCategorias={setCategorias}
                         setLoader={setLoader}
                         setIsMyCatalog={setIsMyCatalog}
                         catalogoId={catalogoId}
                         />
        </div>
      )}
    </div>
  );
};

export default Categorias;
